// Copyright (c) 2016 Deere & Company

import SpaClaim from './components';
import actionCreators from './action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.claims.spa,
    isCkcCustomerFailed: state.customerFailed.ckcCustomerFailed,
    latestPerUnitMeasurements: state.latestPerUnitMeasurements,
    partsGroupedByPartNumber: state.claims.partsGroupedByPartNumber,
    warranties: state.productDetails.warranties
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams, tabm, tcsm} = parentProps;

    const queryParams = parentProps.location.query;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        queryParams,
        routeParams,
        tabm,
        tcsm
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(SpaClaim);



// WEBPACK FOOTER //
// ./src/claim/spa/state-connector.js